module.exports = __webpack_public_path__ + "static/media/profile-style-img.a91376f5.png";